export default __webpack_public_path__ + "media/images/cowboycasino/src-48c4d413cd6097820c1d5414716b9bc6.jpg";